import { Contract } from '../contracts/Contract';

export class ContractTemplate extends Contract {
    active = true;
    chargeTypes = [];
    chargeTypeGroups = [];
    contractTemplatePaySchedules = [];
    contractTemplateBumpRules = [];
    contractTemplateCertifications = [];
    contractTemplateJobTypes = [];
    contractTemplateUSCountyGroups = [];
    isQuickRentalContract = false;
}
